import { zodResolver } from '@hookform/resolvers/zod';
import { WebPushAuthType } from 'modules/webPush/types';
import { FC, PropsWithChildren } from 'react';
import { FormProvider, useForm, useFormContext } from 'react-hook-form';
import { z } from 'zod';
import { WEB_PUSH_INTEGRATION_FORM_DEFAULT_VALUES } from '../constants';

const BaseSchema = z.object({
  fcmSenderId: z.string().min(1, 'FCM sender ID required to save integration'),
});

const schema = z.discriminatedUnion('authType', [
  BaseSchema.extend({
    authType: z.literal(WebPushAuthType.FIREBASE_JSON),
    firebaseJsonFile: z
      .custom<File | undefined>()
      .refine((file) => !!file, 'JSON file required to save integration'),
  }),
  BaseSchema.extend({
    authType: z.literal(WebPushAuthType.FIREBASE),
    fcmServerKey: z.string().min(1, 'FCM server key required to save integration'),
  }),
]);

export type WebPushFormValues = z.infer<typeof schema>;

export const WebPushFormProvider: FC<PropsWithChildren> = ({ children }) => {
  const methods = useForm<WebPushFormValues>({
    defaultValues: WEB_PUSH_INTEGRATION_FORM_DEFAULT_VALUES,
    mode: 'onChange',
    shouldUnregister: true,
    resolver: zodResolver(schema),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};

export const useWebPushFormContext = () => useFormContext<WebPushFormValues>();
